<template>
  <div class="container p0">
    <div class="media-gallery-carousel1">
      <div class="cms-banners-container">
        <no-ssr>
          <carousel
            v-bind="sliderConfig"
            @pageChange="setMuted"
            :infinite="true"
            @transitionStart="pushEvent"
          >
            <slide
              v-for="(banner, index) in validBanners"
              :key="index"
              ref="main-banner"
            >
              <div
                class="offer"
                v-lazy:background-image="getThumbnailPathBig(banner.backgroundImageDesktop, banner.backgroundImageMobile)"
                :style="[banner.backgroundImageDesktop ? { backgroundColor : 'transparent' } : { backgroundColor: '#' + banner.backgroundColor }]"
              >
                <div class="row pd-custom w-100">
                  <div class="col-xs-12 col-md-6 center-xs image">
                    <img v-if="currentPage === index" v-lazy="getThumbnailPath(banner.imageDesktop, banner.imageMobile)" width="750" height="500" class="offer__image" alt="banner image">
                  </div>
                  <div class="col-md-5 ml20 offer__info" :style="{ backgroundColor : '#' + banner.hex }">
                    <div>
                      <h2 class="offer__text-one mt0 weight-400" data-testid="mainSliderTitle" :style="{ color : '#' + banner.text1color }">
                        {{ banner.text1 }}
                      </h2>
                      <p
                        :class="banner.position === 'Large banner 4' ? 'temp-offer__text-two mt0' : 'offer__text-two mt0'"
                        data-testid="mainSliderSubtitle"
                        :style="{ color : '#' + banner.text2color }"
                      >
                        {{ banner.text2 }}
                      </p>
                      <button-outline
                        class="offer__button"
                        :style="{ color : '#' + banner.text2color, borderColor: '#' + banner.text2color, '--button-background-color--hover': '#' + banner.text2color, '--button-color--hover': '#FFFFFF' }"
                        :link="banner.link"
                        :color="$device.isMobile ? 'dark' : 'light'"
                      >
                        {{ $t('View') }}
                      </button-outline>
                    </div>
                  </div>
                </div>
              </div>
            </slide>
          </carousel>
        </no-ssr>
      </div>
    </div>
  </div>
</template>

<script>
import NoSSR from 'vue-no-ssr'
import { getThumbnailPath as _thumbnailHelper } from '@vue-storefront/core/helpers'
import ButtonOutline from 'theme/components/theme/ButtonOutline'

export default {
  name: 'ProductGalleryCarousel',
  components: {
    'Carousel': () => import('vue-carousel').then(Slider => Slider.Carousel),
    'Slide': () => import('vue-carousel').then(Slider => Slider.Slide),
    'no-ssr': NoSSR,
    ButtonOutline
  },
  props: {
    validBanners: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      sliderConfig: {
        perPage: 1,
        paginationEnabled: true,
        navigationEnabled: true,
        autoplayTimeout: 6000,
        paginationActiveColor: '#1396EC',
        paginationColor: '#CFCFCF',
        paginationPosition: 'bottom-overlay',
        navigationNextLabel: '&#10095;',
        navigationPrevLabel: '&#10094;',
        infiniteLoop: true,
        centerMode: true,
        touchDrag: true,
        scrollPerPage: true,
        autoplay: true,
        loop: true
      },
      currentPage: 0,
      isLoad: false,
      pagesArr: []
    }
  },
  computed: {
    data () {
      return this.$store.getters[`cmsBlock/cmsBlocks`]
    }
  },
  methods: {
    pushEvent () {
      if (!this.pagesArr.includes(this.currentPage)) {
        let bannerData = this.$refs['main-banner'][this.currentPage].$attrs && this.$refs['main-banner'][this.currentPage].$attrs.value
        this.$store.commit('ui/VIEW_BANNER', bannerData)
        this.pagesArr.push(this.currentPage)
      }
    },
    getThumbnailPath (urlDesktop, urlMobile) {
      if (!this.$device.isMobile) {
        return _thumbnailHelper(urlDesktop, 750, 500, 'banners')
      } else {
        return _thumbnailHelper(urlMobile, 748, 548, 'banners')
      }
    },
    getThumbnailPathBig (urlDesktop, urlMobile) {
      if (!this.$device.isMobile) {
        return _thumbnailHelper(urlDesktop, 1024, 635, 'banners')
      } else {
        return _thumbnailHelper(urlMobile, 767, 445, 'banners')
      }
    },
    handleSlideClick (banner) {
      this.$router.push(this.localizedRoute('/' + banner.link))
      this.$store.commit('ui/CLICK_BANNER', banner)
    },
    setMuted (currentPage) {
      this.currentPage = currentPage
    }
  }
}
</script>

<style lang="scss">
.media-gallery-carousel1 {
   cursor: pointer;
  .VueCarousel-pagination--bottom-overlay {
    bottom: -35px !important;
  }
  .VueCarousel-navigation-prev {
    left: 20px !important;
  }
  .VueCarousel-navigation-next {
    right: 20px !important;
  }
  .VueCarousel-navigation-button {
    top: initial !important;
    margin-top: 2px;
    background-color: #1396EC !important;
    border-radius: 50%;
    width: 35px !important;
    height: 35px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    font-size: 16px !important;
    color: white !important;
    z-index: 2 !important;
    @media (max-width: 995px) {
      width: 30px !important;
      height: 30px !important;
      font-size: 14px !important;
    }
  }
  .VueCarousel-dot {
    padding: 10px 8px !important;
  }
  .VueCarousel-navigation--disabled {
    display: none !important;
  }
  .VueCarousel-navigation-prev {
    transform: none !important;
  }
  .VueCarousel-navigation-next {
    transform: none !important;
  }
  .VueCarousel-slide {
    max-width: 100%;
  }
}
</style>

<style lang="scss" scoped>
.media-gallery-carousel1 {
  position: relative;
  display: flex;
  padding-top: calc(100% * 1/2.75);
  background-color: #e0e0e0;
  margin-bottom: 50px;
  @media (max-width: 767px) {
    margin-bottom: 35px;
    padding-top: calc(100% * 1/1.1);
  }
  @media (max-width: 550px) {
    padding-top: calc(100% * 1/1);
  }
  @media (max-width: 440px) {
    padding-top: calc(100% * 1/0.85);
  }
  .offer__button:hover {
    background-color: var(--button-background-color--hover);
    color: var(--button-color--hover) !important;
  }
}
.cms-banners-container {
  height: 0;
  top:0;
  width: 100%;
  position: absolute;
}
.pd-custom {
  padding-top: 40px;
  @media (max-width: 767px) {
    width: 100%;
    padding: 0;
  }
}
.offer {
  background-position: bottom left;
  display: flex;
  flex-direction: column;
  -ms-flex-direction: column;
  align-items: center;
  background-size: cover;
  background-repeat: no-repeat;
  opacity: 1;
  transition: 0.3s all;

  &:hover {
    opacity: 0.9;
  }
  .offer__text-one {
    font-size: 26px;
    @media (max-width: 767px) {
      font-size: 18px;
      margin-bottom: 5px;
    }
  }
  .temp-offer__text-two {
    font-size: 24px;
    @media (max-width: 915px) {
      font-size: 16px;
    }
    @media (max-width: 767px) {
      font-size: 15px;
      padding-bottom: 10px;
    }
  }
  .offer__text-two {
    font-size: 38px;
    @media (max-width: 915px) {
      font-size: 24px;
    }
    @media (max-width: 767px) {
      font-size: 16px;
      padding-bottom: 10px;
    }
  }
  &__button {
    @media (max-width: 767px) {
      padding: 11px 50px;
      font-size: 16px;
    }
    display: inline;
    min-width: auto;
    padding: 5px 20px;
    border-width: 2px !important;
    font-size: 30px;
  }
  .image {
    @media (max-width: 767px) {
      padding-top: calc(100% * 1/1.5);
      margin: 0;
    }
    margin-left: 40px;
    position: relative;
    padding-top: calc(100% * 1/2.95);
    img {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      max-width: 750px;
      height: auto;
      max-height: 100%;
    }
  }
  &__info {
    @media (max-width: 767px) {
      div {
        margin-top: 20px;
        top: 0;
        position: absolute;
        width: 100%;
      }
      position: relative;
      padding-top: calc(100% * 1/4.1);
      margin-left: 0;
      text-align: center;
    }
    @media (max-width: 550px) {
      padding-top: calc(100% * 1/3);
    }
    @media (max-width: 440px) {
      padding-top: calc(100% * 1/1.97);
    }
  }
}

</style>
